import React from "react";

/**
 * GlowCard — reusable panel with soft aurora border glow + rounded corners.
 * Wraps the Geneo AI dark surface with a hovering halo that intensifies on hover.
 *
 * Variants: "gold" (warm), "cyan" (cool), "duo" (both — default), "muted"
 */
export function GlowCard({
  variant = "duo",
  hoverable = false,
  className = "",
  bodyClassName = "",
  children,
  testId,
  ...rest
}) {
  const glows = {
    gold: "shadow-[0_0_44px_-14px_rgba(242,201,76,0.35)]",
    cyan: "shadow-[0_0_44px_-14px_rgba(0,229,255,0.35)]",
    duo:
      "shadow-[0_0_36px_-14px_rgba(242,201,76,0.28),0_0_36px_-14px_rgba(0,229,255,0.22)]",
    muted: "shadow-[0_0_20px_-10px_rgba(255,255,255,0.15)]",
  }[variant] || "";

  const hoverGlow = {
    gold: "hover:shadow-[0_0_64px_-14px_rgba(242,201,76,0.55)]",
    cyan: "hover:shadow-[0_0_64px_-14px_rgba(0,229,255,0.55)]",
    duo:
      "hover:shadow-[0_0_56px_-14px_rgba(242,201,76,0.45),0_0_56px_-14px_rgba(0,229,255,0.35)]",
    muted: "hover:shadow-[0_0_30px_-10px_rgba(255,255,255,0.25)]",
  }[variant] || "";

  return (
    <div
      data-testid={testId}
      className={[
        "relative rounded-3xl border border-white/[0.06] overflow-hidden",
        "bg-gradient-to-br from-[#0e0b13]/85 via-[#0a0812]/80 to-[#080810]/85",
        "backdrop-blur-xl",
        "transition-all duration-500",
        glows,
        hoverable ? `hover:-translate-y-0.5 ${hoverGlow}` : "",
        className,
      ].filter(Boolean).join(" ")}
      {...rest}
    >
      {/* Aurora inner rim */}
      <span
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-60"
        style={{
          background:
            "radial-gradient(120% 60% at 0% 0%, rgba(242,201,76,0.06), transparent 55%), " +
            "radial-gradient(120% 60% at 100% 100%, rgba(0,229,255,0.06), transparent 55%)",
        }}
      />
      <div className={`relative ${bodyClassName}`}>
        {children}
      </div>
    </div>
  );
}

export default GlowCard;
